<template>
  <div>
    <h2 v-show="documents.length" class="py-2">Documente</h2>
    <v-row>
      <v-col cols="12">
        <v-hover v-for="(document, i) in documents" :key="i" v-slot="{ hover }">
          <v-card
            class="mb-2"
            outlined
            :elevation="hover ? 5 : 0"
            @click="viewDocument(document.src)"
          >
            <v-card-text>
              <v-row dense>
                <v-col class="flex-grow-1">
                  <v-icon :color="getIconColor(document.mime_type)">{{
                    getIcon(document.mime_type)
                  }}</v-icon
                  >{{ document.name }}
                </v-col>
                <v-col class="flex-grow-0">{{ document.details }}</v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-hover>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'DocumentsList',
  props: {
    documents: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  methods: {
    viewDocument(src) {
      window.open(src)
    },
    getIcon(mimeType) {
      if (mimeType.includes('pdf')) return 'mdi-file-pdf-box'
      if (mimeType.includes('word')) return 'mdi-file-word'
      if (mimeType.includes('image')) return 'mdi-file-image'
      if (mimeType.includes('xml')) return 'mdi-file-excel'
    },
    getIconColor(mimeType) {
      if (mimeType.includes('pdf')) return 'error'
      if (mimeType.includes('word')) return 'blue'
      if (mimeType.includes('image')) return 'warning'
      if (mimeType.includes('xml')) return 'green'
    },
  },
}
</script>
